import MatomoTracker from '@jonkoops/matomo-tracker';
import {
  TrackEventParams,
  TrackPageViewParams,
} from '@jonkoops/matomo-tracker/es/types';

import { isElectron } from '@lmt/unicorn-shared/app/helpers/common';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

let tracker: MatomoTracker | null;

export function initMatomo(url: string, siteId: number) {
  if (!url) return;
  if (!siteId) {
    console.error(
      'MatomoUrl is defined, but siteId is not. Please either remove MatomoUrl(if you want to disable Matomo), or set the siteId',
    );
  }
  window._paq = window._paq ?? [];
  window._paq.push(['setConsentGiven']);
  window._paq.push(['setCookieConsentGiven']);

  tracker = new MatomoTracker({
    urlBase: url,
    siteId: siteId,
    heartBeat: {
      // optional, enabled by default
      active: false, // optional, default value: true
    },
    linkTracking: false, // optional, default value: true
    configurations: {
      // any valid matomo configuration
    },
  });
  tracker.trackPageView();
}

export function trackEvent(params: TrackEventParams) {
  tracker?.trackEvent(params);
}

export function trackPageView(params: TrackPageViewParams) {
  tracker?.trackPageView(params);
}

/*
This hook sends a PageView to matomo on every Location change.
Use it from the Root of your App (but within react-router main component)
 */
export function useMatomoPageTracking() {
  const location = useLocation();

  useEffect(() => {
    trackPageView({
      href: isElectron()
        ? 'https://DESKTOP' + (location.search ? '?' + location.search : '')
        : location.pathname + (location.search ? '?' + location.search : ''),
    });
  }, [location]);
}
